import { Position } from 'geojson';
import { LatLon } from '../classes/coordinates';
import { ICoordinates, IGeoPoint, ILatLng, ILatLon } from '../interfaces/coordinates';

export function toLatLon(geoPoint: IGeoPoint): LatLon {
  if (geoPoint) {
    return new LatLon({
      lat: 'lat' in geoPoint ? (geoPoint as ILatLng).lat : (geoPoint as ICoordinates).latitude,
      lon:
        'lng' in geoPoint
          ? (geoPoint as ILatLng).lng
          : 'lon' in geoPoint
          ? (geoPoint as ILatLon).lon
          : (geoPoint as ICoordinates).longitude,
    });
  }

  return new LatLon();
}

export function positionToLatLon(point: Position, precisionFunction?: (value: number) => number): LatLon {
  if (point && precisionFunction) {
    return new LatLon({
      lat: precisionFunction(point[1]),
      lon: precisionFunction(point[0]),
    });
  }

  if (point) {
    return new LatLon({
      lat: point[1],
      lon: point[0],
    });
  }

  return new LatLon();
}
